import React from 'react';
import { StepIconProps as MuiStepIconProps } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { AbsolutelyPositionedTypography, CheckIcon, StepIconContainer } from './style';

interface StepIconProps extends MuiStepIconProps {
    label: string | null;
    index: number;
    stepsCount: number;
}

const StepIcon = ({ completed, active, label, stepsCount, index }: StepIconProps) => {
    const { t } = useTranslation();

    return (
        <StepIconContainer
            active={active}
            completed={completed}
        >
            {completed ? <CheckIcon fontSize='inherit' /> : null}
            <AbsolutelyPositionedTypography
                isTop
                variant='overline'
                isFirst={index === 0}
                isLast={index === stepsCount}
                color={active ? 'textSecondary' : undefined}
            >
                {t('Step {{stepNumber}}', { stepNumber: index + 1 })}
            </AbsolutelyPositionedTypography>
            <AbsolutelyPositionedTypography
                isFirst={index === 0}
                isLast={index === stepsCount}
                variant='caption'
            >
                {label}
            </AbsolutelyPositionedTypography>
        </StepIconContainer>
    );
};

export default StepIcon;